export class SupplyDocRequest {
    public supplier_code;
    public company_code;
    public language;
}



// WEBPACK FOOTER //
// ./src/app/model/supply-doc/supply_doc_request.model.ts